import loadable from '@loadable/component';

export const ViewVolopPageLoadable = loadable(() => import('./ViewVolopPage'), {
  resolveComponent: (module) => module.ViewVolopPage,
});
